<mat-form-field class="w-full">
    <mat-select [formControl]="params.control" placeholder="{{params.label |transloco}}"
        >
        <mat-option *ngFor="let option of params.options" [value]="option">
            {{ option | transloco }}
        </mat-option>
    </mat-select>
</mat-form-field>